import type { ButtonPriority, ButtonSize } from '@timelyapp/react';
import { Button, ButtonRow } from '@timelyapp/react';
import classNames from 'classnames';
import { EMPTY_ARRAY } from 'constants/defaults';
import React from 'react';
import { notNull } from 'utils/typesafe';
import styles from './SplashMessage.module.scss';

export type SplashMessageButton = {
  text: string;
  priority?: ButtonPriority;
  size?: ButtonSize;
  onClick: () => void;
  isLoading?: boolean;
  disabled?: boolean;
  style?: React.CSSProperties;
};

export interface SplashMessageProps {
  className?: string;
  children?: React.ReactNode;
  centered?: boolean;
  style?: React.CSSProperties;
  variant?: 'emptyContent';
  horizontal?: boolean;
  size?: 'large' | 'small';
  /** Path to image -- may want to accept as `media` and React children for videos */
  image?: string;
  title?: React.ReactChild;
  description?: React.ReactChild;
  subtext?: React.ReactChild;
  buttons?: ReadonlyArray<SplashMessageButton | null>;
}

export default class SplashMessage extends React.PureComponent<SplashMessageProps> {
  static defaultProps = {
    centered: true,
  };
  render() {
    const {
      className,
      centered,
      children,
      variant,
      image,
      title,
      description,
      subtext,
      size = 'large',
      buttons = EMPTY_ARRAY,
      horizontal,
      ...rest
    } = this.props;
    const containerClass = classNames(styles.container, className, styles[`size-${size}`], {
      [styles.centered]: centered && !horizontal,
      [styles[`variant-${variant}`]]: !!variant,
      [styles.horizontal]: horizontal,
    });

    const notNullButtons = buttons.filter(notNull);

    return (
      <div {...rest} className={containerClass}>
        <div>
          {!!image && (
            <div className={styles.image}>
              <img src={image} />
            </div>
          )}
          <div className={styles.mainContent}>
            {!!title && size === 'large' && <h1>{title}</h1>}
            {!!title && size === 'small' && <h4>{title}</h4>}
            {!!description && <div className={styles.description}>{description}</div>}
            {!!notNullButtons.length && (
              <ButtonRow className={styles.buttons}>
                {notNullButtons.map(button => {
                  return (
                    <Button
                      {...button}
                      key={button.text}
                      priority={button.priority || 'xhigh'}
                      size={button.size}
                      onClick={button.onClick}
                    >
                      {button.text}
                    </Button>
                  );
                })}
              </ButtonRow>
            )}
            {!!subtext && <div className={styles.subtext}>{subtext}</div>}
          </div>

          {children}
        </div>
      </div>
    );
  }
}
